import { Dimensions } from 'react-native';

export const ScreenWidth =
    Dimensions.get('window').height > Dimensions.get('window').width
        ? Dimensions.get('window').width
        : Dimensions.get('window').height;
const Iphone6DeviceWidth = 375;

export default class SizeUtil {
    public static getSize = (size: number) => {
        return (size * ScreenWidth) / Iphone6DeviceWidth;
    };
}
